import React, { memo } from 'react';
import { Table } from 'react-bootstrap';
import { displayInfo } from '../EcwConstants';

interface RecordRow {
    bcScan?: string | null;
    rxName?: string | null;
    ndc?: string | null;
    lotNo?: string | null;
    expDate?: string | null;
    list2?: string | null;
    qty?: number | string | null;
    unit?: string | null;
    waste?: number | string | null;
}

interface RecordInfoTableProps {
    recordTableData: RecordRow[];
}

const RecordInfoTable: React.FC<RecordInfoTableProps> = ({ recordTableData }) => {
    if (!recordTableData?.length) return null;

    return (
        <div className="record-item-info-table-wrapper">
            <Table bordered={false} hover className="m-0">
                <thead>
                    <tr>
                        <th>Barcode</th>
                        <th>Item Name</th>
                        <th>NDC/SKU</th>
                        <th>Lot</th>
                        <th>Exp.Date</th>
                        <th>Stock</th>
                        <th>Quantity</th>
                        <th>Unit</th>
                        <th>Waste</th>
                    </tr>
                </thead>
                <tbody>
                    {recordTableData.map((data, index) => (
                        <tr key={index}>
                            <td>{displayInfo(data.bcScan)}</td>
                            <td>{displayInfo(data.rxName)}</td>
                            <td>{displayInfo(data.ndc)}</td>
                            <td>{displayInfo(data.lotNo)}</td>
                            <td>{displayInfo(data.expDate)}</td>
                            <td>{displayInfo(data.list2)}</td>
                            <td>{displayInfo(data.qty)}</td>
                            <td>{displayInfo(data.unit)}</td>
                            <td>{displayInfo(data.waste)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default memo(RecordInfoTable);